import useAuthenticatedWebsocket from './useAuthenticatedWebSocket';

export default function useSendMessageReceived() {
  const { sendJsonMessage } = useAuthenticatedWebsocket();

  return (deliveryToken) => {
    sendJsonMessage({
      action: 'message_received',
      body: {
        delivery_token: deliveryToken,
      },
    });
  };
}
